import { SourceFilterValue } from './types';

export { LANGUAGE_FILTER_ALL } from '@/shared/config';

export const SOURCE_FILTER_ALL = 'all' as const;

export const SOURCE_FILTER_VALUES: SourceFilterValue[] = [
  SOURCE_FILTER_ALL,
  'system',
  'community',
];

export const SEARCH_DEBOUNCE_MS = 250;

export const TEMPLATES_PAGE_SIZE = 48;

export const SKELETON_CARD_COUNT = 4;

export const SKELETON_CARD_KEYS = Array.from(
  { length: SKELETON_CARD_COUNT },
  (_, index) => `skeleton-${index}`,
);

export const EMPTY_STATE_ICON_SIZE = 48;

export const COMMUNITY_CATALOG_PARAM = {
  q: 'q',
  source: 'source',
  language: 'language',
} as const;
